var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8337 10.2918V8.43695C15.8337 7.78937 15.8337 7.46637 15.7133 7.17504C15.593 6.8845 15.3642 6.65491 14.9058 6.19733L11.1565 2.448C10.7615 2.05295 10.5643 1.85583 10.3189 1.73866C10.2681 1.71426 10.2161 1.69259 10.163 1.67375C9.90724 1.5835 9.62778 1.5835 9.06966 1.5835C6.5007 1.5835 5.21583 1.5835 4.34578 2.28491C4.1701 2.42657 4.01007 2.58661 3.86841 2.76229C3.16699 3.63391 3.16699 4.9172 3.16699 7.48616V10.2918M10.292 1.97933V2.37516C10.292 4.614 10.292 5.7342 10.9879 6.42929C11.683 7.12516 12.8032 7.12516 15.042 7.12516H15.4378M15.6357 12.6668H13.6566C13.4466 12.6668 13.2452 12.7502 13.0968 12.8987C12.9483 13.0472 12.8649 13.2485 12.8649 13.4585V15.0418M12.8649 15.0418V17.4168M12.8649 15.0418H15.2399M3.36491 17.4168V15.4377M3.36491 15.4377V12.6668H4.75033C5.11776 12.6668 5.47015 12.8128 5.72996 13.0726C5.98978 13.3324 6.13574 13.6848 6.13574 14.0522C6.13574 14.4197 5.98978 14.7721 5.72996 15.0319C5.47015 15.2917 5.11776 15.4377 4.75033 15.4377H3.36491ZM8.11491 12.6668H9.30241C9.72234 12.6668 10.1251 12.8336 10.422 13.1306C10.7189 13.4275 10.8857 13.8302 10.8857 14.2502V15.8335C10.8857 16.2534 10.7189 16.6561 10.422 16.9531C10.1251 17.25 9.72234 17.4168 9.30241 17.4168H8.11491V12.6668Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.985ddcdda0e9e50d56eef84f97afd08a.svg";
export { ForwardRef as ReactComponent };